module.exports = __webpack_public_path__ + "img/watch-inside.fec693a7.svg";